import moment from 'moment';
import DepsService from 'services/dependencies';

const CONTEXT = 'manage-inventory';

// Helpers

const setUrl = (tabId) => {
  switch (tabId) {
    case 'packs': {
      return DepsService.rest.inventory.packs.list.url;
    }
    case 'games': {
      return DepsService.rest.inventory.games.list.url;
    }
    case 'inventoryHistory': {
      return DepsService.rest.inventory.history.list.url;
    }
    case 'orderHistory': {
      return DepsService.rest.inventory.ordersHistory.list.url;
    }
    case 'liability': {
      return DepsService.rest.inventory.liability.list.url;
    }
    case 'pack': {
      return DepsService.rest.history.inventoryHistory.details.url;
    }
    case 'order': {
      return DepsService.rest.inventory.orderHistory.details.url;
    }
    default:
      return '';
  }
};

export const getOrderDetailsFromPack = (pack) => {
  const { orderNumber, prefixedTrackingNumber, orderIssuedDate, orderType, orderConfirmedDate, grossValue, manifestNumber } = pack;
  return {
    orderNumber,
    prefixedTrackingNumber,
    orderIssuedDate,
    orderType,
    orderConfirmedDate,
    grossValue,
    manifestNumber,
  };
};

export const downloadManageInventoryReportByTab = (config) => {
  const { retailerId, filters, tabId, ...params } = config;

  const url = setUrl(tabId);
  const queryParams = {
    ...filters,
    ...params,
  };
  const urlParams = { retailerId };
  const headers = { Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };

  if (url) return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);

  // eslint-disable-next-line no-console
  console.error(`MANAGE_INVENTORY_EXPORTS - cannot find URL: ${url} for given tab: ${tabId}`);
};

export const downloadManageInventoryDetailedReportByTab = (config) => {
  const { tabId, orderId, ...params } = config;

  const url = setUrl(tabId);
  const queryParams = {
    ...params,
  };
  const urlParams = { orderId };
  const headers = { Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };

  if (url) return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);

  // eslint-disable-next-line no-console
  console.error(`MANAGE_INVENTORY_EXPORTS - cannot find URL: ${url} for given tab: ${tabId}`);
};

export const fetchGamesList = (config) => {
  const { retailerId, ...params } = config;

  const { url } = DepsService.rest.inventory.games.list;
  const queryParams = { ...params };
  const urlParams = { retailerId };

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

export const fetchPacksGrossValue = (config) => {
  const { retailerId, ...params } = config;

  const { url } = DepsService.rest.inventory.packs.grossValue;
  const queryParams = { ...params };
  const urlParams = { retailerId };

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

export const fetchPacksList = (config) => {
  const { retailerId, ...params } = config;

  const { url } = DepsService.rest.inventory.packs.list;
  const queryParams = { ...params };
  const urlParams = { retailerId };

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

export const fetchPackDetails = (config) => {
  const { retailerId, ...params } = config;

  const { url } = DepsService.rest.history.inventoryHistory.details;
  const queryParams = { ...params };
  const urlParams = { retailerId };

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

export const fetchOrderDetails = async ({ orderId, ...config }) => {
  const { url } = DepsService.rest.inventory.orderHistory.details;
  const queryParams = { ...config };
  const urlParams = { orderId };

  const packs = await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);

  const orderDetails = getOrderDetailsFromPack(packs[0]);

  return {
    ...orderDetails,
    packs,
  };
};

export const fetchInstantGamesTransitionsHistory = (config) => {
  const { retailerId, ...params } = config;

  const startDate = params.filters.startDate ? moment(params.filters.startDate).format('YYYY-MM-DD') : null;
  const endDate = params.filters.endDate ? moment(params.filters.endDate).format('YYYY-MM-DD') : null;

  const { url } = DepsService.rest.inventory.history.list;
  const queryParams = {
    ...params,
    filters: {
      ...params.filters,
      startDate,
      endDate,
    },
  };
  const urlParams = { retailerId };

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

export const fetchLiabilities = ({ retailerId, ...queryParams }) => {
  const { url } = DepsService.rest.inventory.liability.list;
  const urlParams = { retailerId };

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};

export const fetchOrderHistoryList = ({ retailerId, ...queryParams }) => {
  const { url } = DepsService.rest.inventory.ordersHistory.list;
  const urlParams = { retailerId };

  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/resources/manage-inventory.api.js